import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/api/client";
import { useTranslation } from "react-i18next";
import { Plus, Trash2, Send, Info } from "lucide-react";

export default function AdminNotifications() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);
  const [msg, setMsg] = useState("");
  const [posting, setPosting] = useState(false);
  const [err, setErr] = useState("");
  const [okMsg, setOkMsg] = useState("");

  const load = () => api.get("/notifications/all").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const post = async () => {
    setErr(""); setOkMsg("");
    if (!msg.trim()) { setErr(t("admin.notifRequired")); return; }
    setPosting(true);
    try {
      await api.post("/notifications", { message: msg.trim() });
      setMsg("");
      setOkMsg(t("admin.notifPosted"));
      load();
      setTimeout(() => setOkMsg(""), 1500);
    } catch (e) { setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
    finally { setPosting(false); }
  };

  const del = async (id) => {
    if (!window.confirm(t("admin.notifConfirmDelete"))) return;
    await api.delete(`/notifications/${id}`);
    load();
  };

  return (
    <div>
      <h1 className="page-title">{t("admin.notifications")}</h1>
      <p className="page-sub">{t("admin.notifSub")}</p>

      <div className="card" style={{ marginBottom: 20 }}>
        <div className="card-body">
          <div className="card-title" style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Plus size={16} /> {t("admin.notifNew")}
          </div>
          <textarea
            className="textarea"
            data-testid="notif-message"
            placeholder={t("admin.notifPlaceholder")}
            value={msg}
            onChange={(e) => setMsg(e.target.value)}
            maxLength={500}
            rows={3}
          />
          <div style={{ fontSize: 11, color: "#64748B", marginTop: 4 }}>{msg.length} / 500</div>
          {err && <div style={{ color: "#DC2626", fontSize: 13, marginTop: 8 }} data-testid="notif-err">{err}</div>}
          {okMsg && <div style={{ color: "#16A34A", fontSize: 13, marginTop: 8 }} data-testid="notif-ok">{okMsg}</div>}
          <div className="row-actions" style={{ marginTop: 12 }}>
            <button className="btn btn-primary" onClick={post} disabled={posting || !msg.trim()} data-testid="notif-post">
              <Send size={14} /> {posting ? t("common.loading") : t("admin.notifPost")}
            </button>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="card-title" style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Info size={16} /> {t("admin.notifList")} ({items.length})
          </div>
          {items.length === 0 && <div style={{ color: "#64748B", fontSize: 13 }}>{t("admin.notifEmpty")}</div>}
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }} data-testid="notif-list">
            {items.map((n) => (
              <div key={n.id} className="notification-row" data-testid={`notif-item-${n.id}`}>
                <div style={{ flex: 1 }}>
                  <div style={{ whiteSpace: "pre-wrap", fontSize: 14 }}>{n.message}</div>
                  <div style={{ fontSize: 11, color: "#64748B", marginTop: 4 }}>
                    {n.created_by_name || "-"} · {n.created_at ? new Date(n.created_at).toLocaleString() : ""}
                  </div>
                </div>
                <button
                  className="btn btn-danger"
                  style={{ padding: "6px 10px", fontSize: 12 }}
                  onClick={() => del(n.id)}
                  data-testid={`notif-del-${n.id}`}
                >
                  <Trash2 size={12} />
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
